import { ExperienceBlockProps } from "../components/ExperienceBlock/ExperienceBlock";

export const ExperienceData: ExperienceBlockProps[] = [
  {
    title: "Software Engineer",
    subTitle: "Players Health",
    description: `Developing and maintaining software applications by collaborating with other team members to implement new features and improvements. Expertise in full-stack development and experience with financial applications.`,
    location: "Remote",
    duration: "September 2022 - Current",
    image: "/images/ph_logo.png",
  },
  {
    title: "Full-Stack Engineer",
    subTitle: "Fast Way Hydroponics",
    description: `Collaborated with a co-founder to deliver an internal web/mobile app. Worked with a small team of software engineers and facilitated workloads while tackling full-stack duties.`,
    location: "Remote",
    duration: "February 2021 - March 2022",
    image: "/images/fastway.png",
    textAsImage: ["Fast Way", "Hydroponics"],
  },
  {
    title: "Teaching Assistant",
    subTitle: "Coding Dojo",
    description: `Support instructors by assisting in teaching through small lectures, live demos, and frequent check-ins with students to identify what students are working on and how to support their learning.`,
    location: "Remote",
    duration: "September 2021 - September 2022",
    image: "/images/dojo.png",
  },
];
